/*
 * IGNIERE §280（2026-10-07 代表の実機の指摘「CATEGORY を押して枝が開く動作が早すぎる。当初エレガントなモーションを想定していたはず」）
 * 絞り込み（一覧・検索の結果）と検索の窓の軸（CATEGORY・SCENE・BRAND・PRICE）の開閉に、
 * design-components §16.16 {component.disclosure} の「開閉は滑らかに（0.4 秒・cubic-bezier(.4,0,.2,1)）」を当てる。
 * 実測（直す前）：中身が 40ms 未満で開いていた＝<details> の素の開閉（動きなし）。
 * 所作：開くは 400ms・閉じるは 320ms（§164-7「開くはゆっくり・閉じるは速く」）。動きを減らす設定の時は動かさない。
 * 作り：<summary> の押下を受け、<details> 自体の高さを Web Animations で動かす（Horizon の本体は触らない）。
 * open 属性の付け外しは今までどおり（toggle の合図も出る）＝各パネルの JS（開いた軸の記憶など）はそのまま動く。
 */
(function () {
  if (window.__igDisclosureMotion) return;
  window.__igDisclosureMotion = true;

  var SCOPE = '#MainContent .ig-filter-panel details.facets__panel, dialog-component.search-modal details.ig-sp__grp';
  var OPEN_MS = 400;
  var CLOSE_MS = 320;
  var EASE = 'cubic-bezier(.4, 0, .2, 1)';
  var running = new WeakMap();

  function reduced() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) { return false; }
  }
  function closedHeight(details, summary) {
    var cs = getComputedStyle(details);
    return summary.offsetHeight +
      parseFloat(cs.paddingTop || 0) + parseFloat(cs.paddingBottom || 0) +
      parseFloat(cs.borderTopWidth || 0) + parseFloat(cs.borderBottomWidth || 0);
  }
  function finish(details) {
    var a = running.get(details);
    if (a) { try { a.cancel(); } catch (_) {} }
    running.delete(details);
    details.style.height = '';
    details.style.overflow = '';
  }
  function animate(details, from, to, ms, done) {
    details.style.overflow = 'hidden';
    var a = details.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: ms, easing: EASE });
    running.set(details, a);
    a.onfinish = function () { if (done) done(); finish(details); };
    a.oncancel = function () { running.delete(details); };
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.matches(SCOPE)) return;
    if (reduced()) return;
    e.preventDefault();

    var start = details.offsetHeight;
    var prev = running.get(details);
    if (prev) { try { prev.cancel(); } catch (_) {} running.delete(details); }

    if (!details.open) {
      details.style.overflow = 'hidden';
      details.style.height = start + 'px';         // 先に今の高さで止めてから開く＝1 コマだけ全部見えるちらつきを出さない
      details.open = true;
      requestAnimationFrame(function () {
        var end = details.scrollHeight;
        if (!end || end <= start) { finish(details); return; }
        animate(details, start, end, OPEN_MS);
      });
    } else {
      var end = closedHeight(details, summary);
      animate(details, start, end, CLOSE_MS, function () { details.open = false; });
    }
  }, true);
})();
